<template>
  <v-card :height="zoomed?500:300" :width="zoomed?500:width" :class="zoomed?'pa-4':'mx-2 mt-2 mb-4 pa-4'" :ripple="false" hover>

    <v-btn v-if="enableDelete" icon large @click="$emit('delete')" color="red" style="position:absolute;right:0px;top:0px"><v-icon>mdi-close-circle</v-icon></v-btn>
    <v-btn v-else-if="!$vuetify.breakpoint.mobile && !noZoom && !zoomed" icon small @click="$emit('zoom')" style="position:absolute;right:10px;top:10px"><v-icon>mdi-magnify-plus-outline</v-icon></v-btn>
    <template v-else-if="!noZoom && zoomed">
      <v-btn icon v-if="print" small @click="$emit('print')" style="position:absolute;right:40px;top:10px"><v-icon>mdi-printer</v-icon></v-btn>
      <v-btn icon small @click="$emit('close')" style="position:absolute;right:10px;top:10px"><v-icon>mdi-close</v-icon></v-btn>
    </template>

    <div :class="{'text-subtitle-2':!zoomed,'text-h6':zoomed}">{{title}}</div>
    <slot/>
  </v-card>
</template>

<script>
export default {
  name: 'DashboardWidget',
  props: {
    title: {type:String, required:true},
    zoomed: {type:Boolean, required:false, default:false},
    noZoom: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    print: {type:Boolean, required:false, default:false}
  }
}
</script>